var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"number"},[_vm._v("404")]),_c('app-button',{attrs:{"tag":"router-link","to":{ name: 'Dashboard' },"blue":""}},[_vm._v("Go to dashboard")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }